/* eslint-disable import/prefer-default-export */
import { Transform, Type } from 'class-transformer';
import { Timestamp } from 'firebase/firestore';

export function isTimestamp(value: unknown): boolean {
  const object = value && typeof value === 'object' ? value as Record<string, unknown> : {};

  return Boolean('seconds' in object && 'nanoseconds' in object);
}

export function IsTimestamp(): PropertyDecorator {
  return (target, key) => {
    Type(() => Object)(target, key);

    Transform(
      ({ value }: { value: Date | Timestamp }) => {
        if (value instanceof Timestamp || isTimestamp(value)) {
          const obj = value as Timestamp;

          return new Timestamp(obj.seconds, obj.nanoseconds);
        }

        return value ? Timestamp.fromDate(value) : undefined;
      },
      { toPlainOnly: true }
    )(target, key);

    Transform(
      ({ value }): Date | undefined => {
        if (value instanceof Timestamp || isTimestamp(value)) {
          const obj = value as Timestamp;

          return new Timestamp(obj.seconds, obj.nanoseconds).toDate();
        }

        return undefined;
      },
      { toClassOnly: true }
    )(target, key);
  };
}
